import React from 'react';
import { MapPin, Video, Trophy } from 'lucide-react';

const steps = [
  {
    icon: MapPin,
    title: 'See the Prize',
    description:
      'Arrive at any par 3 and see what prize is on the line.',
  },
  {
    icon: Video,
    title: 'Record Your Shot',
    description:
      'Use the in-app camera with smart zoom to record your tee shot.',
  },
  {
    icon: Trophy,
    title: 'Win the Prize',
    description:
      'Capture your hole-in-one on camera and the prize is yours.',
  },
];

const HowItWorks: React.FC = () => {
  return (
    <section id="how-it-works" className="py-28 sm:py-36 bg-gray-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900">
            How It Works
          </h2>
        </div>

        <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-16 md:gap-6 relative">
          {/* Connector lines — desktop only, two segments that stop at circle edges */}
          <div className="hidden md:block absolute top-10 left-[calc(16.67%+44px)] w-[calc(33.33%-88px)] h-0.5 bg-gray-200" />
          <div className="hidden md:block absolute top-10 right-[calc(16.67%+44px)] w-[calc(33.33%-88px)] h-0.5 bg-gray-200" />

          {steps.map((step, i) => (
            <div key={step.title} className="flex flex-col items-center text-center relative">
              {/* Numbered circle */}
              <div
                className="w-20 h-20 rounded-full flex items-center justify-center mb-6 relative z-10"
                style={{ backgroundColor: '#9CB75A15' }}
              >
                <step.icon size={32} style={{ color: '#9CB75A' }} strokeWidth={1.8} />
              </div>

              {/* Step number */}
              <span
                className="text-sm font-bold mb-2"
                style={{ color: '#9CB75A' }}
              >
                Step {i + 1}
              </span>

              <h3 className="text-xl font-bold text-gray-900 mb-2">
                {step.title}
              </h3>
              <p className="text-gray-600 leading-relaxed max-w-xs">
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
